import React from 'react';
import cx from 'classnames';

export interface TreeNodeProps {
  node: {
    type: string;
    extension?: string;
    open?: boolean;
    name: string;
    refrenceId?: string;
    children?: TreeNodeProps['node'][];
  };
  onFolderToggle?: (node: TreeNodeProps['node']) => void;
  selectedFile?: { refrenceId: string };
}

const TreeNode: React.FC<TreeNodeProps> = ({
  node,
  onFolderToggle,
  selectedFile,
}) => {
  // const { node, onFolderToggle } = props;
  const [nodeData, setNodeData] = React.useState<TreeNodeProps['node']>(node);
  const handleClick = () => {
    onFolderToggle && onFolderToggle(nodeData);
  };
  React.useEffect(() => {
    setNodeData(node);
  }, [node]);
  return (
    <li>
      <span
        className={cx(nodeData.type, nodeData.extension, {
          open: nodeData.open,
          selected:
            nodeData.type === 'file' &&
            selectedFile?.refrenceId === nodeData.refrenceId,
        })}
        onClick={handleClick}
      >
        {nodeData.name}
      </span>
      {nodeData.children && (
        <ul
          className={
            nodeData.type === 'folder' && nodeData.open
              ? 'show-content'
              : 'hide-content'
          }
        >
          {nodeData.children.map((child: any, index: number) => (
            <TreeNode
              key={index}
              node={child}
              onFolderToggle={onFolderToggle}
              selectedFile={selectedFile}
            />
          ))}
        </ul>
      )}
    </li>
  );
};
export default TreeNode;
